import script from "./CollegeSituation.vue?vue&type=script&lang=ts&setup=true"
export * from "./CollegeSituation.vue?vue&type=script&lang=ts&setup=true"

import "./CollegeSituation.vue?vue&type=style&index=0&id=44b7d8db&scoped=true&lang=css"
import "./CollegeSituation.vue?vue&type=style&index=1&id=44b7d8db&lang=css"

import exportComponent from "D:\\code\\frontEndCode\\collegeSubjectPage\\page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44b7d8db"]])

export default __exports__